module.exports = __webpack_public_path__ + "img/video-play-button.ad74503f.png";